import { render } from "./MorePage.vue?vue&type=template&id=09d3207a"
import script from "./MorePage.vue?vue&type=script&lang=js"
export * from "./MorePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__